import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc, updateDoc, collection, getDocs, addDoc } from 'firebase/firestore';
import { db } from '../../services/firebaseConnection';
import Header from '../../components/Header';
import Title from '../../components/Title';
import { toast } from 'react-toastify';
import { GrDocumentTxt } from "react-icons/gr";
import { FaRegTrashAlt } from "react-icons/fa";
import Select from 'react-select';

export default function EditarRelatorio() {
  const { id } = useParams();
  const [relatorio, setRelatorio] = useState(null);
  const [usuarios, setUsuarios] = useState([]);
  const [som, setSom] = useState('');
  const [atriu, setAtriu] = useState('');
  const [corredor, setCorredor] = useState('');
  const [banheiro, setBanheiro] = useState('');
  const [newDay, setNewDay] = useState({ date: null, time: '00:00' });
  const [estacionamento, setEstacionamento] = useState('');
  const [showAllUsers, setShowAllUsers] = useState(false);

  const getFilteredUsers = () => {
    if (showAllUsers || !relatorio) {
      return usuarios;
    }
  
    return usuarios.filter(user => {
      return (
        user.cidade === relatorio.cidade &&
        user.igreja === relatorio.igreja &&
        user.cargo === relatorio.cargo
      );
    });
  };

  const filteredUsers = getFilteredUsers();
  const options = filteredUsers.map(user => ({
    value: user.id,
    label: user.name,
  }));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadReport = async () => {
      try {
        const relatorioDoc = await getDoc(doc(db, 'Reports', id));
        if (relatorioDoc.exists()) {
          const relatorioData = { id: relatorioDoc.id, ...relatorioDoc.data() };
          setRelatorio(relatorioData);

          const igrejaId = relatorioData.igreja;

          const igrejaDoc = await getDoc(doc(db, 'Igreja', igrejaId));

          if (igrejaDoc.exists()) {
            const igrejaData = igrejaDoc.data();

            const atriu = igrejaData.atriu || '';
            const corredor = igrejaData.corredor || '';
            const banheiro = igrejaData.banheiro || '';
            const estacionamento = igrejaData.estacionamento || '';
            const som = igrejaData.som || '';

            setAtriu(atriu);
            setCorredor(corredor);
            setBanheiro(banheiro);
            setEstacionamento(estacionamento);
            setSom(som);
          }

          const usuariosSnapshot = await getDocs(collection(db, 'User'));
          const usuariosData = usuariosSnapshot.docs.map((doc) => ({
            cargo: doc.data().cargo,
            celular: doc.data().celular,
            cidade: doc.data().cidade,
            datanasc: doc.data().datanasc,
            email: doc.data().email,
            genero: doc.data().genero,
            id: doc.id,
            igreja: doc.data().igreja,
            name: doc.data().name,
          }));
          setUsuarios(usuariosData);
        } else {
          toast.error('Relatório não encontrado!');
        }
      } catch (error) {
        toast.error('Erro ao carregar relatório.');
        console.error("Erro ao carregar o relatório:", error);
      }
      setLoading(false);
    };

    loadReport();
  }, [id]);

  const handleUserChange = (dateIndex, location, personIndex, selectedOption) => {
    const selectedUser = usuarios.find(user => user.id === selectedOption.value);
    const updatedReport = { ...relatorio };

    if (!updatedReport.report[dateIndex][location]) {
      updatedReport.report[dateIndex][location] = [];
    }

    updatedReport.report[dateIndex][location][personIndex] = {
      cargo: selectedUser.cargo,
      celular: selectedUser.celular,
      cidade: selectedUser.cidade,
      datanasc: selectedUser.datanasc,
      email: selectedUser.email,
      genero: selectedUser.genero,
      id: selectedUser.id,
      igreja: selectedUser.igreja,
      name: selectedUser.name,
    };

    setRelatorio(updatedReport);
  };

  const handleAddDay = () => {
    const now = new Date();
    now.setHours(now.getHours() + 3);
    setNewDay({
      date: now.toISOString().split('T')[0],
      time: now.toTimeString().split(':').slice(0, 2).join(':')
    });
  };

  const handleAddPerson = (dateIndex, location) => {
    const updatedReport = { ...relatorio };
    if (!updatedReport.report[dateIndex][location]) {
      updatedReport.report[dateIndex][location] = [];
    }
    updatedReport.report[dateIndex][location].push({ id: '', name: '' });
    setRelatorio(updatedReport);
  };

  const handleRemovePerson = (dateIndex, location, personIndex) => {
    const updatedReport = { ...relatorio };
    updatedReport.report[dateIndex][location].splice(personIndex, 1);
    setRelatorio(updatedReport);
  };

  const handleToggleActive = async () => {
    if (!relatorio) return;

    const storedUser = localStorage.getItem('@userLogado');
    if (!storedUser) {
      console.error('Usuário não encontrado no localStorage.');
      toast.error('Erro ao obter usuário logado.');
      return;
    }
    const { uid: userId, name: userName } = JSON.parse(storedUser);

    try {
      const updatedStatus = !relatorio.ativo;
      await updateDoc(doc(db, 'Reports', id), { ativo: updatedStatus });
      setRelatorio({ ...relatorio, ativo: updatedStatus });

      const timestamp = new Date();
      await addDoc(collection(db, 'Log'), {
        userId: userId,
        userName: userName,
        reportId: id,
        action: 'Relatorio-Atv',
        timestamp: timestamp,
      });

      toast.success(`Relatório ${updatedStatus ? 'ativado' : 'desativado'} com sucesso!`);
    } catch (error) {
      toast.error('Erro ao alterar status do relatório.');
    }
  };

  const handleToggleAtual = async () => {
    if (!relatorio) return;
  
    const storedUser = localStorage.getItem('@userLogado');
    if (!storedUser) {
      console.error('Usuário não encontrado no localStorage.');
      toast.error('Erro ao obter usuário logado.');
      return;
    }
    const { uid: userId, name: userName } = JSON.parse(storedUser);
  
    try {
      const updatedStatus = !relatorio.atual;
      await updateDoc(doc(db, 'Reports', id), { atual: updatedStatus });
      setRelatorio({ ...relatorio, atual: updatedStatus });
  
      const timestamp = new Date();
      await addDoc(collection(db, 'Log'), {
        userId: userId,
        userName: userName,
        reportId: id,
        action: 'Relatorio-Atual',
        timestamp: timestamp,
      });
  
      toast.success(`Relatório marcado como ${updatedStatus ? 'atual' : 'não atual'} com sucesso!`);
    } catch (error) {
      toast.error('Erro ao alterar status atual do relatório.');
    }
  };

  const handleSave = async () => {
    try {
      await updateDoc(doc(db, 'Reports', id), { report: relatorio.report });

      const storedUser = localStorage.getItem('@userLogado');
      if (!storedUser) {
        console.error('Usuário não encontrado no localStorage.');
        toast.error('Erro ao obter usuário logado.');
        return;
      }
      const { uid: userId, name: userName } = JSON.parse(storedUser);

      const timestamp = new Date();
      await addDoc(collection(db, 'Log'), {
        userId: userId,
        userName: userName,
        reportId: id,
        action: 'Relatorio-Up',
        timestamp: timestamp,
      });

      toast.success('Relatório atualizado com sucesso!');
    } catch (error) {
      toast.error('Erro ao atualizar relatório.');
      console.error('Erro ao salvar alterações:', error);
    }
  };

  const handleFixAllDates = async () => {
    if (!relatorio) return;

    if (!window.confirm('Isso irá corrigir todas as datas deste relatório para o formato ISO correto. Deseja continuar?')) {
      return;
    }

    try {
      const updatedReport = { ...relatorio };
      let fixedCount = 0;

      updatedReport.report = updatedReport.report.map(entry => {
        const currentDate = entry.date;
        
        if (typeof currentDate === 'string' && currentDate.includes('UTC')) {
          const parsedDate = new Date(currentDate);
          entry.date = parsedDate.toISOString();
          fixedCount++;
        } else if (currentDate && currentDate.seconds) {
          const firebaseDate = new Date(currentDate.seconds * 1000);
          entry.date = firebaseDate.toISOString();
          fixedCount++;
        } else if (currentDate instanceof Date) {
          entry.date = currentDate.toISOString();
          fixedCount++;
        } else if (typeof currentDate === 'string' && !currentDate.endsWith('Z')) {
          const parsedDate = new Date(currentDate);
          if (!isNaN(parsedDate.getTime())) {
            entry.date = parsedDate.toISOString();
            fixedCount++;
          }
        }

        return entry;
      });

      await updateDoc(doc(db, 'Reports', id), { report: updatedReport.report });
      setRelatorio(updatedReport);

      const storedUser = localStorage.getItem('@userLogado');
      if (storedUser) {
        const { uid: userId, name: userName } = JSON.parse(storedUser);
        const timestamp = new Date();
        await addDoc(collection(db, 'Log'), {
          userId: userId,
          userName: userName,
          reportId: id,
          action: 'Relatorio-FixDates',
          timestamp: timestamp,
        });
      }

      toast.success(`${fixedCount} datas foram corrigidas com sucesso!`);
    } catch (error) {
      toast.error('Erro ao corrigir datas.');
      console.error('Erro ao corrigir datas:', error);
    }
  };

  const hasSom = (entry) => entry.som && entry.som.length > 0;

  const adjustTimezone = (date) => {
    if (!date) return { date: 'Data não disponível', time: 'Hora não disponível' };

    if (date.seconds) {
      const firebaseDate = new Date(date.seconds * 1000);
      firebaseDate.setHours(firebaseDate.getHours() + 3);

      const formattedDate = firebaseDate.toLocaleString('pt-BR', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });

      const formattedTime = firebaseDate.toLocaleString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });

      return { date: formattedDate, time: formattedTime };
    }

    const newDate = new Date(date);
    newDate.setHours(newDate.getHours() + 3);

    const formattedDate = newDate.toLocaleString('pt-BR', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });

    const formattedTime = newDate.toLocaleString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });

    return { date: formattedDate, time: formattedTime };
  };

  const handleDeleteDay = (dateIndex) => {
    if (window.confirm("Você tem certeza que deseja excluir este dia? Esta ação não pode ser desfeita.")) {
      const updatedReport = { ...relatorio };
      updatedReport.report.splice(dateIndex, 1);
      setRelatorio(updatedReport);
      toast.success('Dia excluído com sucesso!');
    }
  };

  return (
    <div>
      <Header />
      <div className="content">
        <Title name="Editar Relatório">
          <GrDocumentTxt size={25} />
        </Title>
        <div className="container">
          {loading ? (
            <p>Carregando...</p>
          ) : (
            relatorio && (
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                  <h2>{relatorio.nomeRelatorio}</h2>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button
                      onClick={handleToggleActive}
                      style={{
                        backgroundColor: relatorio.ativo ? '#e90303' : '#03c9e9',
                        color: '#FFF',
                        padding: '10px 15px',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                      }}
                    >
                      {relatorio.ativo ? 'Desativar' : 'Ativar'}
                    </button>
                    <button
                      onClick={handleToggleAtual}
                      style={{
                        backgroundColor: relatorio.atual ? '#28a745' : '#6c757d',
                        color: '#FFF',
                        padding: '10px 15px',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                      }}
                    >
                      {relatorio.atual ? 'Atual' : 'Não Atual'}
                    </button>
                    {/* <button
                      onClick={handleFixAllDates}
                      style={{
                        backgroundColor: '#ff9800',
                        color: '#FFF',
                        padding: '10px 15px',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                      }}
                      title="Corrige todas as datas para o formato ISO correto"
                    >
                      🔧 Corrigir Datas
                    </button> */}
                  </div>
                </div>
                {newDay.date && (
                  <div style={{ marginBottom: '15px', display: 'flex', alignItems: 'center' }}>
                    <input
                      type="date"
                      value={newDay.date}
                      onChange={(e) => setNewDay({ ...newDay, date: e.target.value })}
                      style={{ marginRight: '10px' }}
                    />
                    <input
                      type="time"
                      value={newDay.time}
                      onChange={(e) => setNewDay({ ...newDay, time: e.target.value })}
                      style={{ marginRight: '10px' }}
                    />
                    <button
                      className="button_rel"
                      onClick={() => {
                        const combinedDateTime = new Date(`${newDay.date}T${newDay.time}:00`);
                        combinedDateTime.setHours(combinedDateTime.getHours() - 3);
                        const isoDate = combinedDateTime.toISOString();
                        
                        const updatedReport = { ...relatorio };
                        updatedReport.report.push({
                          date: isoDate,
                          atriu: [],
                          corredor: [],
                          banheiro: [],
                          estacionamento: [],
                          som: [],
                        });
                        setRelatorio(updatedReport);
                        setNewDay({ date: null, time: '00:00' });
                        toast.success('Data adicionada com sucesso!');
                      }}
                      style={{ marginRight: '10px' }}
                    >
                      Confirmar Data e Hora
                    </button>
                  </div>
                )}
                
                <div style={{ 
                marginBottom: '15px', 
                display: 'flex', 
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px',
                backgroundColor: '#f5f5f5',
                borderRadius: '5px'
              }}>
                <button className="button_rel" onClick={handleAddDay} style={{ marginBottom: '15px' }}>
                  + Adicionar Dia
                </button>
                <div  style={{ display: 'flex', alignItems: 'center' }}>
                <input
                  type="checkbox"
                  id="showAllUsers"
                  checked={showAllUsers}
                  onChange={(e) => setShowAllUsers(e.target.checked)}
                  style={{ marginRight: '10px' }}
                />
                <span htmlFor="showAllUsers" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                  Mostrar todos os usuários do sistema
                </span>
                <span style={{ 
                  marginLeft: '10px', 
                  fontSize: '12px', 
                  color: '#666' 
                }}>
                  ({showAllUsers ? usuarios.length : filteredUsers.length} usuários disponíveis)
                </span>
                </div>
              </div>
                <table className="relatorio-table">
                  <thead>
                    <tr>
                      <th>Data</th>
                      {relatorio.report.some(hasSom) ? (
                        <th>{som || "Som"}</th>
                      ) : (
                        <>
                          <th>{atriu || "Átrio"}</th>
                          <th>{corredor || "Pedidos de oração"}</th>
                          <th>{banheiro || "Sanitário"}</th>
                          <th>{estacionamento || "Estacionamento"}</th>
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {relatorio.report
                      .sort((a, b) => {
                        const dateA = a.date?.seconds ? new Date(a.date.seconds * 1000) : new Date(a.date);
                        const dateB = b.date?.seconds ? new Date(b.date.seconds * 1000) : new Date(b.date);
                        return dateA - dateB;
                      })
                      .map((entry, dateIndex) => {
                        const renderLocation = (location) => (
                          <>
                            {entry[location]?.map((person, personIndex) => (
                              <div key={personIndex} style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                                <Select
                                  value={person.id ? { value: person.id, label: person.name } : null}
                                  onChange={(selectedOption) =>
                                    handleUserChange(dateIndex, location, personIndex, selectedOption)
                                  }
                                  options={options}
                                  placeholder="Selecione um usuário"
                                  isSearchable
                                  getOptionLabel={(option) => option.label}
                                  getOptionValue={(option) => option.value}
                                  filterOption={(option, inputValue) =>
                                    option.label.toLowerCase().includes(inputValue.toLowerCase())
                                  }
                                  styles={{
                                    container: (base) => ({ ...base, flex: 1, marginRight: "10px" }),
                                  }}
                                />
                                  <FaRegTrashAlt
                                    onClick={() => handleRemovePerson(dateIndex, location, personIndex)}
                                    style={{ cursor: "pointer", color: "#e90303" }}
                                    size={20}
                                  />
                              </div>
                            ))}
                            <button className="button_rel" onClick={() => handleAddPerson(dateIndex, location)}>
                              + Adicionar Pessoa
                            </button>
                          </>
                        );

                        return (
                          <tr key={dateIndex}>
                            <td data-label="Data" className="td_data">
                              {adjustTimezone(entry.date).date} {adjustTimezone(entry.date).time}
                              <br />
                                <FaRegTrashAlt
                                  style={{ cursor: "pointer", color: "#e90303", marginTop: "15px" }}
                                  onClick={() => handleDeleteDay(dateIndex)}
                                  size={20}
                                />
                            </td>
                            {hasSom(entry) ? (
                              <td data-label={som || "Som"}>{renderLocation('som')}</td>
                            ) : (
                              <>
                                <td data-label={atriu || "Átrio"}>{renderLocation('atriu')}</td>
                                <td data-label={corredor || "Pedidos de oração"}>{renderLocation('corredor')}</td>
                                <td data-label={banheiro || "Sanitário"}>{renderLocation('banheiro')}</td>
                                <td data-label={estacionamento || "Estacionamento"}>{renderLocation('estacionamento')}</td>
                              </>
                            )}
                          </tr>
                        );
                      })}
                  </tbody>
                </table>

                <button className="button_rel" onClick={handleSave}>
                  Salvar Alterações
                </button>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
}
